import styled from "styled-components";

interface MainHeaderProps {
  bg?: string;
}

export const MainHeader = styled.div`
  background-color: ${(p: MainHeaderProps) =>
    p.bg ? p.bg : " var(--color-menu-bg)"};
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
  @media (max-width: 850px) {
    justify-content: space-between;
  }

  @media (max-width: 768px) {
    .control-users {
        justify-content: space-between;

        .panel-user {
            .align-items-center {
                .media {
                    .text-panel-user {
                        display: none;
                    }
                }
            }
        }
    }
}
`;

interface TextMenuProps {
  color?: string;
}
export const TextMenu = styled.a` 
  color: ${(p: TextMenuProps) => (p.color ? p.color : "var(--color-text)")};
`;

interface TextAppProps {
  color?: string;
}

export const TextApp = styled.span`
  color: ${(p: TextAppProps) => (p.color ? p.color : "var(--color-text)")};
  text-align: left;
  font: normal normal bold 24px/22px MontserratRegular;
  letter-spacing: 0.74px;
  opacity: 1;
`;

interface SideMenuBarProps {
  bg: string;
  color?: string;
}

export const SideMenuBar = styled.ul`
  margin: 0 30px 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  z-index: 30px;
  overflow-x: scroll;
  width: 100%;

  ::-webkit-scrollbar {
    display: none;
  }

  > li {
    list-style: none;
    padding: 10px;
    margin: 10px;
    background-color: ${(p: SideMenuBarProps) => p.bg};

    > div a {
      text-decoration: none;
      text-align: center;
      font: normal normal normal 24px/29px MontserratRegular;
      letter-spacing: 0.55px;
      color: ${(p: SideMenuBarProps) => p.color};
      font-size: clamp(0.9em, 1.1rem, 1.5rem);
      :hover {
        color: #000000;
      }
    }
    :hover {
      background-color: #9c94947f;
      border-radius: 5px;
    }
    > ul {
      display: none;
      top: 85%;
      width: 100%;
      position: absolute;
      z-index: 30;
      opacity: 1;
      min-height: 50vh;
      max-height: 90vh;
      overflow-y: scroll;
      transition: 0.2s 0s;
      padding-left: 0;
      border-radius: 5px;
      > li {
        list-style: none;
        width: 13%;
        background-color: ${(p: SideMenuBarProps) => p.bg};
        border: 1px solid #707070;
        > div {
          padding: 10px;
          background-color: ${(p: SideMenuBarProps) => p.bg};
          width: 100%;
          height: 100%;
          a {
            text-decoration: none;
            text-align: center;
            font: normal normal normal 24px/29px MontserratRegular;
            letter-spacing: 0.55px;
            color: ${(p: SideMenuBarProps) => p.color};
            font-size: clamp(0.8rem, 0.8rem, 0.9rem);
            :hover {
              color: #000000;
              font-weight: bold;
            }
          }
          :hover {
            background-color: #9c94947f;
            width: 100%;
            height: 100%;
          }
        }

        > ul {
          display: none;
          position: absolute;
          left: 12%;
          margin-left: 2px;
          margin-top: -30px;
          padding-left: 0;
          background-color: ${(p: SideMenuBarProps) => p.bg};
          > li {
            list-style: none;
            padding: 5px 25px 5px 10px;
            border: 1px solid #707070;
            display: flex;
            justify-content: space-between;
            > div a {
              text-decoration: none;
              text-align: center;
              font: normal normal normal 14px/18px MontserratRegular;
              letter-spacing: 0.55px;
              color: ${(p: SideMenuBarProps) => p.color};
              font-size: clamp(0.8rem, 0.8rem, 0.9rem);
              :hover {
                color: #000000;
              }
            }
            :hover {
              background-color: #9c94947f;
            }
            img {
              margin-left: 20px;
              cursor: pointer;
            }
          }
        }
        :hover > ul {
          display: block;
        }
      }
    }
    :hover > ul {
      display: block;
    }
  }

  @media (max-width: 850px) {
    background-color: ${(p: SideMenuBarProps) => p.bg};
    margin: 0 0 0 0;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0%;
    width: 100vw;
    height: 100vh;
    zindex: 20px;

    > li {
      > ul {
        position: relative;
        top: 0%;
        width: 100%;
        > li {
          width: 100%;
          > ul {
            position: relative;
            top: 0%;
            width: 100%;
            left: 0;
            margin-left: 2px;
            margin-top: 0;
            padding-left: 0;
            margin-top: 10px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    background-color: ${(p: SideMenuBarProps) => p.bg};
    margin: 0 0 0 0;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    position: absolute;
    top: 0%;
    width: 100vw;
    height: 100vh;
    zindex: 20px;

    > li {
      > ul {
        position: relative;
        top: 0%;
        width: 100%;
        > li {
          width: 100%;
          > ul {
            position: relative;
            top: 0%;
            width: 100%;
            left: 0;
            margin-left: 2px;
            margin-top: 0;
            padding-left: 0;
            margin-top: 10px;
          }
        }
      }
    }
  }
`;

interface DropdownMenuItem {
  color: string;
  hoverColor: string;
}

export const DropdownMenuItem = styled.span`
  color: ${(p: DropdownMenuItem) => p.color};
  width: 100%;
  display: block;
  padding-left: 15px;
  padding-top: 5px;
  padding-bottom: 5px;

  &:hover {
    color: ${(p: DropdownMenuItem) => p.hoverColor};
  }
`;
